module.exports = __webpack_public_path__ + "static/img/金融征信_0.f18b6ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/金融征信_0.jpg
// module id = Zy2j
// module chunks = 1